import { ToastType } from "../../utils/types";
import { getToastColor } from "../toast/nofitication";
import { Icon } from "./icon";

export const ToastIcon = ({ type }: { type: ToastType }) => {
  return (
    <div className="bg-white border border-border-grey rounded-full p-1">
      <div
        className={`${getToastColor(
          type
        )} border !border-transparent rounded-full p-[4px] md:p-[6px]`}
      >
        <Icon
          svg={`toast-${type}-icon`}
          width={28}
          height={28}
          className="max-md:hidden"
        />
        <Icon
          svg={`toast-${type}-icon`}
          width={14}
          height={14}
          className="md:hidden"
        />
      </div>
    </div>
  );
};
